import { BrandIdKeys } from '@seek/brand-types';
import { useSelector, shallowEqual } from 'react-redux';
import { NIL, v5 as uuidv5 } from 'uuid';

import type { AppState, FormData } from 'src/types/appState';

export const useGenerateJobIdempotencyKey = (): string => {
  const { brandId, formData, draftId, buyUpsell } = useSelector(
    (state: AppState) => ({
      brandId: state.formData.brand?.[BrandIdKeys.id],
      draftId: state.session.draftId,
      buyUpsell: state.session.buyUpSell,
      formData: state.formData,
    }),
    shallowEqual,
  );

  const draftData: Omit<
    FormData,
    | 'draftProgress'
    | 'flowType'
    | 'logoId'
    | 'linkOutApplyVia'
    | 'paymentOption'
    | 'sourceProductId'
    | 'suggestedCategoryId'
  > = {
    brandId,
    draftId,
    buyUpsell,
    ...formData,
  };
  // Remove properties which are not part of the job
  delete draftData.draftProgress;
  delete draftData.flowType;
  delete draftData.linkOutApplyVia;
  delete draftData.logoId;
  delete draftData.paymentOption;
  delete draftData.sourceProductId;
  delete draftData.suggestedCategoryId;

  return uuidv5(JSON.stringify(draftData), NIL);
};
